module.exports = __webpack_public_path__ + "static/blueprint3-optimised-6a6326ffacbdeaccdd88b1ca2fec4d35.jpg";